import consts from "consts/index"
import FormatterHelper from "helpers/formatter"

import i18n from "consts/i18n"
import { LOCALE } from "consts/locale"

export const generateButtonText = ({ programIsUnavailable }) => {
  if (programIsUnavailable) {
    return i18n.deepLinkPage.programUnavailableBtn
  }

  return i18n.deepLinkPage.watchNow
}

export const useProgramDisplayBreadcrumbs = ({ program, isReplay, channel, fromChannel }) => {
  const breadcrumb = [
    {
      route: FormatterHelper.basic(consts.routes.seoHome, { locale: LOCALE }),
      name: "Programme TV",
    },
  ]

  if (program.isAvailable()) {
    breadcrumb.push({
      route: isReplay ? program.getChannel().getReplayUrl() : program.getChannel().getUrl(),
      name: `${channel.getTitle()} en ${isReplay ? "replay" : "direct"}`,
    })
  }

  if (!fromChannel) {
    breadcrumb.push({
      route: program.getUrl(),
      name: program.data.title,
    })
  }

  return breadcrumb
}
